import { createRouter, createWebHashHistory } from 'vue-router'
import { useAdminStore } from '@/stores/AdminStore'
import WebDisabledView from '@/views/WebDisabledView.vue'
import AdminLoginView from '@/views/admin/AdminLoginView.vue'
import AdminLayout from '@/views/admin/AdminLayout.vue'
import { webDisabled, webDisableAllowAdmin } from '@/utils/webShutdown'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/admin/dashboard',
    },
    {
      path: '/web-disabled',
      name: 'web-disabled',
      component: WebDisabledView,
      meta: { requiresAuth: false },
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: AdminLoginView,
      meta: { requiresAuth: false },
    },
    {
      path: '/admin',
      component: AdminLayout,
      redirect: '/admin/dashboard',
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        {
          path: 'dashboard',
          name: 'admin-dashboard',
          component: () => import('@/views/admin/dashboard/DashboardView.vue'),
          meta: { title: '仪表盘', permission: 'dashboard' },
        },
        {
          path: 'users',
          name: 'admin-users',
          component: () => import('@/views/admin/users/UserListView.vue'),
          meta: { title: '用户管理', permission: 'users' },
        },
        {
          path: 'users/:uid',
          name: 'admin-user-detail',
          component: () => import('@/views/admin/users/UserDetailView.vue'),
          meta: { title: '用户详情', permission: 'users' },
        },
        {
          path: 'sign-statistics',
          name: 'admin-sign-statistics',
          component: () => import('@/views/admin/statistics/SignStatisticsView.vue'),
          meta: { title: '签到统计', permission: 'sign-statistics' },
        },
        {
          path: 'logs',
          name: 'admin-logs',
          component: () => import('@/views/admin/logs/SystemLogView.vue'),
          meta: { title: '日志管理', permission: 'logs' },
        },
        {
          path: 'announcements',
          name: 'admin-announcements',
          component: () => import('@/views/admin/announcements/AnnouncementManageView.vue'),
          meta: { title: '公告中心', permission: 'announcements' },
        },
        {
          path: 'config',
          name: 'admin-config',
          component: () => import('@/views/admin/config/SystemConfigView.vue'),
          meta: { title: '配置管理', permission: 'config' },
        },
        {
          path: 'watch/keys',
          name: 'admin-watch-keys',
          component: () => import('@/views/admin/watch/WatchKeyManageView.vue'),
          meta: { title: '卡密配置', permission: 'watch-keys' },
        },
        {
          path: 'agents',
          name: 'admin-agents',
          component: () => import('@/views/admin/agents/AgentManageView.vue'),
          meta: { title: '代理管理', permission: 'agents' },
        },
        {
          path: 'abuse',
          name: 'admin-abuse',
          component: () => import('@/views/admin/abuse/AbuseCenterView.vue'),
          meta: { title: '风控中心', permission: 'abuse' },
        },
      ],
    },
  ],
})

router.beforeEach((to) => {
  if (webDisabled && to.name !== 'web-disabled') {
    const isAdminPath = to.path.startsWith('/admin')
    if (!(webDisableAllowAdmin && isAdminPath)) {
      return {
        name: 'web-disabled',
        query: { from: to.fullPath || to.path || '/' },
      }
    }
  }

  if (to.path.startsWith('/admin')) {
    const adminStore = useAdminStore()
    if (to.name === 'admin-login') {
      if (adminStore.isLoggedIn) return { name: 'admin-dashboard' }
      return true
    }
    if (!adminStore.isLoggedIn) {
      return { name: 'admin-login', query: { redirect: to.fullPath } }
    }
    const requiredPermission = to.meta?.permission
    if (requiredPermission && !adminStore.hasPermission(requiredPermission)) {
      return { name: adminStore.homeRouteName }
    }
  }

  return true
})

export default router
